<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{data.sysText.leaveInfoActionItemsTemplatesDialog_title | titlecase}}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close()" [attr.aria-label]="data.sysText.goBack">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>
<mat-dialog-content>
  <div class="subtitle1">
    <p class="body2">{{ data.sysText.leaveInfoActionItemsTemplatesDialog_message }}</p>
  </div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-autocomplete-field
      [control]="form.controls.actionItemsTemplate"
      [icon]="'assignment_turned_in'"
      [options]="data.options"
      [label]="data.sysText.selectTemplateLabel">
    </app-autocomplete-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (!(isMobile$ | async)) {
    <button mat-stroked-button class="button" color="accent" (click)="close()">
      {{data.sysText.goBack}}
    </button>
  }
  <button mat-stroked-button class="button" color="accent"
    [disabled]="" (click)="onSubmit()">
    {{data.sysText.continueAndSave}}
  </button>
</mat-dialog-actions>